enum DealType {
  produced = 'produced',
  purchased = 'purchased',
  sold = 'sold',
  spent = 'spent',
  lost = 'lost',
  leftover = 'leftover',
  recycled = 'recycled',
  self_consumed = 'self_consumed',
  processed = 'processed',
  moved = 'moved',
}

export default DealType;
